<p-accordion multiple="true">
    <p-accordionTab [selected]="true" header="Indirect Rates">
        <ef-indirect-rate-structure-container
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        ></ef-indirect-rate-structure-container>
    </p-accordionTab>
    <p-accordionTab header="Indirect Cost Structure (Cost Centers)">
        <ef-indirect-rate-cost-center-container
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        ></ef-indirect-rate-cost-center-container>
    </p-accordionTab>
    <p-accordionTab header="Indirect Rate Elements">
        <ef-indirect-rate-rule-container
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        ></ef-indirect-rate-rule-container>
    </p-accordionTab>
</p-accordion>
